import CategoriesSlider from "./components/categories-slider";
import HeaderMenu from "./components/header-menu";
// import HeroSlider from "./components/hero-slider";
import Modal from "./components/modal";
import Select from "./components/select";
import CategoriesMenu from "./components/categories-menu";
// import "./components/map";
import Tabs from "./components/tabs";
import Subcategories from "./components/subcategories";
import CharacteristicsAccordion from "./components/characteristics-accordion";
import RangeSlider from "./components/range-slider";
import Filter from "./components/filter";
import ProductSlider from "./components/product-slider";
import RecommendedSlider from "./components/recommended-slider";
import ShowPassword from "./components/show-password";
import DadataCountry from "./components/dadata-country";
import PhoneMask from "./components/phoneMask";
import AvatarInput from "./components/avatar-input";
import RateStars from "./components/rate-stars";

document.addEventListener("DOMContentLoaded", function () {
  Select();
  HeaderMenu();
  // HeroSlider();
  CategoriesSlider();
  Modal();
  CategoriesMenu();
  Tabs();
  Subcategories();
  CharacteristicsAccordion();
  RangeSlider();
  Filter();
  RecommendedSlider();
  ProductSlider();
  ShowPassword();
  DadataCountry();
  PhoneMask();
  AvatarInput();
  RateStars();
});
